/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TokenCreatePayment = {
    properties: {
        billingAccountId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        tokenType: {
            type: 'TokenType',
            isRequired: true,
        },
        last4: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        firstName: {
            type: 'string',
            isNullable: true,
        },
        lastName: {
            type: 'string',
            isNullable: true,
        },
        streetAddress: {
            type: 'string',
            isNullable: true,
        },
        city: {
            type: 'string',
            isNullable: true,
        },
        state: {
            type: 'string',
            isNullable: true,
        },
        zip: {
            type: 'string',
            isNullable: true,
        },
        emailAddress: {
            type: 'string',
            isNullable: true,
        },
        cardType: {
            type: 'CreditCardTypeEnum',
        },
        expirationMonth: {
            type: 'number',
            isNullable: true,
            format: 'int32',
        },
        expirationYear: {
            type: 'number',
            isNullable: true,
            format: 'int32',
        },
        bankName: {
            type: 'string',
            isNullable: true,
        },
        achType: {
            type: 'ACHTypeEnum',
        },
        achAccountHolderType: {
            type: 'ACHAccountHolderTypeEnum',
        },
    },
};